const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://api.nexflowcrm.com/api/v1';

export async function fetchApi<T>(endpoint: string, options?: RequestInit, fallbackData?: T): Promise<T> {
  try {
    const token = localStorage.getItem('auth_token');
    const authHeaders: Record<string, string> = {};
    if (token) {
      authHeaders['Authorization'] = `Bearer ${token.trim()}`;
    }

    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
        ...options?.headers,
      },
      ...options,
    });

    if (!res.ok) {
      const errorJson = await res.json().catch(() => null);
      const errMsg = errorJson?.message || `API error: ${res.statusText} (${res.status})`;
      throw new Error(errMsg);
    }

    const json = await res.json();
    return json.data !== undefined ? json.data : json;
  } catch (error) {
    console.warn(`[API Service] Request to ${endpoint} failed, using fallback/mock data if available.`, error);
    if (fallbackData !== undefined) {
      return fallbackData;
    }
    throw error;
  }
}
